/**
 * Clamps puzzle size to valid range [2, 8]
 *
 * Ensures puzzle board dimensions stay within supported bounds.
 * Converts input to number and applies min/max constraints.
 *
 * @param {number|string} n - Desired size (will be converted to number)
 * @returns {number} Clamped size between 2 and 8 (inclusive)
 *
 * @example
 * clampSize(5)   // 5
 * clampSize(1)   // 2 (clamped to min)
 * clampSize(10)  // 8 (clamped to max)
 * clampSize('4') // 4 (string converted)
 * clampSize(null) // 3 (default fallback)
 */
export function clampSize (n) {
  const s = Number(n) || 3
  if (s < 2) return 2
  if (s > 8) return 8
  return s
}
